import request from '@/utils/request';

// 获取岗位列表（分页）
export var getPositionList = function getPositionList(data) {
  return request({
    url: '/api/permission/Position',
    method: 'GET',
    data: data
  });
};

// 获取岗位下拉列表（公司+部门+岗位）
export var getPositionSelector = function getPositionSelector() {
  return request({
    url: '/api/permission/Position/Selector',
    method: 'GET'
  });
};

// 新建岗位
export var createPosition = function createPosition(data) {
  return request({
    url: '/api/permission/Position',
    method: 'POST',
    data: data
  });
};

// 修改岗位
export var updatePosition = function updatePosition(data) {
  return request({
    url: "/api/permission/Position/".concat(data.id),
    method: 'PUT',
    data: data
  });
};

// 获取岗位信息
export var getPositionInfo = function getPositionInfo(id) {
  return request({
    url: "/api/permission/Position/".concat(id),
    method: 'GET'
  });
};

// 删除岗位
export var delPosition = function delPosition(id) {
  return request({
    url: "/api/permission/Position/".concat(id),
    method: 'DELETE'
  });
};

// 更新岗位状态
export var updatePositionState = function updatePositionState(id) {
  return request({
    url: "/api/permission/Position/".concat(id, "/Actions/State"),
    method: 'PUT'
  });
};

// 获取全部岗位管理信息列表
export var getPositionListAll = function getPositionListAll() {
  return request({
    url: '/api/permission/Position/All',
    method: 'GET'
  });
};